import {ProductTourType} from '@toolify/server/src/enum/ProductTourType'

export const isProductTourAutoOfferEnabled = true

export const productTourAutoOfferAnchorPollIntervalMs = 100

export const productTourAutoOfferAnchorPollTimeoutMs = 3000

export const productTourAutoOfferMinAnchoredSteps = 3

export const productTourAutoOfferStablePollCount = 3

export const productTourVersionByType: Record<ProductTourType, number> = {
  [ProductTourType.Main]: 1,
  [ProductTourType.Database]: 1,
  [ProductTourType.Document]: 1,
}
